<template>
  <div class="paymentStatus">
    <div class="left"><span>{{ orderDetails.statusName }}</span><span>￥{{ orderDetails.totalPrice ? orderDetails.totalPrice : '0' }}</span></div>
    <div v-if="orderDetails.itemList" class="right"><span>门票</span><span>X {{ ticketTotel }}张</span></div>
  </div>
</template>

<script>
export default {
  name: "paymentStatus",
  props:['orderDetails'],
  data() {
    return {
      ticketTotel: 0,
    }
  },
  watch: {
    orderDetails: {
      handler(value){
        this.ticketTotel = value.itemList.reduce((cur, pre) => {
          return cur += Number(pre.playCount)
        }, 0);
      },
    }
  },
};
</script>

<style scoped lang='less'>
.paymentStatus {
  padding: 0.533333rem 0.346667rem;
  font-size: 0.533333rem;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  line-height: 0.373333rem * 2;
  .left {
    span:first-child {
      color: #222328;
    }
    span:last-child {
      color: #BF2424;
      margin-left: 0.666667rem;
    }
  }
  .right {
    color: #333333;
    font-size: 0.426667rem;
    font-weight: 400;
    span:first-child {
      margin-right: 0.4rem;
    }
  }
}
</style>
